export default __webpack_public_path__ + "static/why-2-36da17acdb10e23ea87cd0316ae15e4c.png";